import React from 'react'

import { useLocation, Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Badge, Tooltip } from 'antd'

const MenuItem = ({ label, route, iconName, showLabel, dot }) => {
  const location = useLocation()
  let active = route === location.pathname
  if (
    !active &&
    route === '/shifts-manager' &&
    location.pathname === '/presets-manager'
  ) {
    active = true
  }

  return (
    <Link to={route}>
      <Tooltip placement='right' title={label}>
        <div
          className={
            'flex-row inner-spacing menu-item ' + (active ? 'active ' : '')
          }
        >
          <Badge dot count={dot ? 1 : 0}>
            <div
              style={{
                minWidth: '36px',
                textAlign: 'center',
                marginRight: '10px'
              }}
            >
              <FontAwesomeIcon icon={iconName} style={{ textAlign: 'left' }} />
            </div>
          </Badge>
          <div style={{ whiteSpace: 'nowrap', overflow: 'hidden' }}>
            {showLabel ? label : ''}
          </div>
        </div>
      </Tooltip>
    </Link>
  )
}

export default MenuItem
